import { IAuth0Config, IMasqueradeAuth0Config } from "../interfaces";
import { auth0EnvConfigs } from "./index";

/** MultiAuth minting client ids, fixed per tenant rather than destination SPA. */
const MULTI_AUTH_CLIENT_IDS = {
  test: "8Nqzhciq90qjg1OoaZX9tLbxuPBflgog",
  staging: "s76TvEB6JgjSBIbVspwEgTrPwDBOXtws",
  prod: "WBTC6lN6kJc1FMrj3qjGLo0uuYPljdzx",
} as const;

/** Distinguishes the two config shapes; required-field validation is separate. */
export const isMasqueradeAuth0Config = (
  auth0Config: IAuth0Config | IMasqueradeAuth0Config
): auth0Config is IMasqueradeAuth0Config =>
  auth0Config != null && "environment" in auth0Config;

export const getCustomDomain = (
  environment: IMasqueradeAuth0Config["environment"]
): string => auth0EnvConfigs[environment].customDomain;

export const getMultiAuthClientId = (
  environment: IMasqueradeAuth0Config["environment"]
): string => MULTI_AUTH_CLIENT_IDS[environment];

export const getApiKey = (
  environment: IMasqueradeAuth0Config["environment"]
): string => auth0EnvConfigs[environment].apiKey;

export const getKrakenApiPath = (
  environment: IMasqueradeAuth0Config["environment"]
): string => auth0EnvConfigs[environment].krakenApiPath;

/** Validate runtime callers too, since JavaScript can bypass the required TS fields. */
export function assertMasqueradeAuth0ConfigIsValid(
  auth0Config: IMasqueradeAuth0Config
): void {
  if (auth0Config == null) {
    throw new Error("Masquerade Auth0 config is required");
  }
  const requiredFields: (keyof IMasqueradeAuth0Config)[] = [
    "environment",
    "audience",
    "clientId",
    "scope",
    "useRefreshTokens",
  ];
  for (const field of requiredFields) {
    if (auth0Config[field] == null) {
      throw new Error(`Masquerade Auth0 config field "${field}" is required`);
    }
  }
  if (!["test", "staging", "prod"].includes(auth0Config.environment)) {
    throw new Error(
      "Masquerade Auth0 config environment must be test, staging or prod"
    );
  }
}
